import { useCallback, useEffect, useState } from 'react';
import { NotificationSettings } from '@/types/notificationSettings';
import { notificationSettingsService } from '@/services/notificationSettings.service';

export function useNotificationSettings() {
  const [settings, setSettings] = useState<NotificationSettings | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);

  const fetchSettings = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await notificationSettingsService.getSettings();
      setSettings(data);
    } catch (err: any) {
      setError('Failed to load notification settings');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSettings();
  }, [fetchSettings]);

  const updateSettings = useCallback(async (updates: Partial<NotificationSettings>) => {
    setSaving(true);
    setError(null);
    try {
      const data = await notificationSettingsService.updateSettings(updates);
      setSettings(data);
    } catch (err: any) {
      setError('Failed to update notification settings');
    } finally {
      setSaving(false);
    }
  }, []);

  return { settings, loading, error, saving, updateSettings, refetch: fetchSettings };
}
